import { render } from "./BasiceLayOut.vue?vue&type=template&id=37990da4&scoped=true"
import script from "./BasiceLayOut.vue?vue&type=script&lang=js"
export * from "./BasiceLayOut.vue?vue&type=script&lang=js"

import "./BasiceLayOut.vue?vue&type=style&index=0&id=37990da4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37990da4"]])

export default __exports__